import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { alarmService, Alarm as AlarmType } from 'services/alarmService';
import * as S from './Alarm.styles';

function Alarm() {
  const navigate = useNavigate();
  const [alarms, setAlarms] = useState<AlarmType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchAlarms = async () => {
      try {
        const data = await alarmService.getMyAlarms();
        setAlarms(data);
      } catch (error) {
        console.error('Failed to fetch alarms:', error);
        setAlarms([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAlarms();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const getAlarmIcon = (type: string) => {
    // RESERVATION, RETURN, etc.
    return type === 'RESERVATION' ? '🔔' : '📢';
  };

  const formatDate = (isoString: string): string => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}.${month}.${day} ${hours}:${minutes}`;
  };

  const newAlarms = alarms.filter((alarm) => !alarm.checked);
  const oldAlarms = alarms.filter((alarm) => alarm.checked);

  const renderAlarm = (alarm: AlarmType) => (
    <S.AlarmCard key={alarm.id}>
      <S.AlarmHeader>
        <S.AlarmIcon>{getAlarmIcon(alarm.type)}</S.AlarmIcon>
        <S.AlarmTitle>{alarm.title}</S.AlarmTitle>
      </S.AlarmHeader>
      <S.AlarmContent>{alarm.message}</S.AlarmContent>
      <S.AlarmDate>{formatDate(alarm.scheduledTime)}</S.AlarmDate>
    </S.AlarmCard>
  );

  return (
    <S.Container>
      <S.Header>
        <S.BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </S.BackButton>
        <S.Title>알림</S.Title>
      </S.Header>

      <S.Content>
        {isLoading ? (
          <S.EmptyContainer>로딩 중...</S.EmptyContainer>
        ) : alarms.length === 0 ? (
          <S.EmptyContainer>알림이 없습니다.</S.EmptyContainer>
        ) : (
          <>
            {newAlarms.map(renderAlarm)}
            {newAlarms.length > 0 && oldAlarms.length > 0 && (
              <S.NewAlarmDivider>
                <S.NewAlarmDividerText>이전 알림</S.NewAlarmDividerText>
              </S.NewAlarmDivider>
            )}
            {oldAlarms.map(renderAlarm)}
          </>
        )}
      </S.Content>
    </S.Container>
  );
}

export default Alarm;
